import React from "react"

export const Button = ({ variant = "default", className = "", children, ...props }) => {
  const baseStyles = "px-4 py-2 rounded-md font-medium transition-colors"
  const variants = {
    default: "bg-green-500 text-white hover:bg-green-600",
    outline: "border border-green-500 text-green-500 hover:bg-green-500 hover:text-white",
  }

  return (
    <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  )
}

